// @flow

// Types
import type {
// Token,
} from 'fc-auth/types'

// Sagas
import { authenticate as authenticate_ } from 'fc-auth'
import { __post } from 'hfty-fetch'

// Effect Managers
import { call } from 'redux-saga/effects'

// Local Types
type AuthenticateArgs = {
  username: string,
  password: string,
}

// Exports
/**
 * authenticate - Submits authentication credentials to the server
 *
 * @param  {string}   username    The user's username
 * @param  {string}   password    The user's password
 * @returns {string}  Returns the authentication token if authentication was successfull.
 */
export default function *authenticate
({username, password}: AuthenticateArgs): Generator<*, *, *> {
  return yield call(authenticate_, { username, password, __post })
}
